import React from 'react';
import { AppSwitch, AppTimePicker } from '@pro-sto/ui';
import type { DayScheduleFormData } from './types';
import './SchedulePage.css';

interface DayScheduleRowProps {
  dayKey?: string;
  dayName: string;
  value: DayScheduleFormData;
  onChange: (value: DayScheduleFormData) => void;
  errorOpen?: string;
  errorClose?: string;
}

const DayScheduleRow: React.FC<DayScheduleRowProps> = ({ dayKey, dayName, value, onChange, errorOpen, errorClose }) => {
  const handleOpenTimeChange = (time: string) => {
    onChange({ ...value, open: time });
  };

  const handleCloseTimeChange = (time: string) => {
    onChange({ ...value, close: time });
  };

  const handleWorkingDayToggle = (checked: boolean) => {
    onChange({ ...value, isClosed: !checked });
  };

  const testIdSuffix = dayKey || dayName.toLowerCase();

  return (
    <div className="schedule-page__day-row" data-testid={`day-schedule-${testIdSuffix}`}>
      <span className="schedule-page__day-name">{dayName}</span>
      <div className="schedule-page__day-controls">
        <AppSwitch
          checked={!value.isClosed}
          onChange={handleWorkingDayToggle}
          size="M"
          data-testid={`day-toggle-${testIdSuffix}`}
        />
        {value.isClosed ? (
          <span className="schedule-page__day-closed-label">Выходной</span>
        ) : (
          <div className="schedule-page__day-controls-wrapper">
            <div className="schedule-page__time-range-container">
              <AppTimePicker
                value={value.open}
                onChange={handleOpenTimeChange}
                placeholder="Открытие"
                error={errorOpen}
                data-testid={`day-start-time-${testIdSuffix}`}
              />
              <div className="schedule-page__time-separator" />
              <AppTimePicker
                value={value.close}
                onChange={handleCloseTimeChange}
                placeholder="Закрытие"
                error={errorClose}
                data-testid={`day-end-time-${testIdSuffix}`}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DayScheduleRow;
